import { Navigate, useRoutes } from 'react-router-dom';
import NProgress from 'nprogress';
// layouts
import DashboardLayout from './layouts/dashboard';
import { useAuth } from 'hooks/useAuthContext';

// import LoginPage from './pages/temp/LoginPage';
import Page404 from './pages/temp/Page404';
import Profile from 'pages/temp/Profile';

import JobList from 'pages/job/JobList';
// import JobDescription from 'pages/job/JobDescription';
import JobDescription from 'components/job-application/JobDescription';
import Dashboard from 'components/admin/Dashboard';

import RegistrationUploadResume from 'components/registration-upload-resume/RegistrationUploadResume';
import BasicProfile from 'pages/candidate/BasicProfile';
// import WorkAndSummary from 'pages/candidate/WorkAndSummary';
// import AddWorkHistoryForm from 'pages/candidate/AddWorkHistoryForm';
// import AddEducationForm from 'pages/candidate/AddEducationForm';
// import Resume from 'pages/candidate/AddResume';
import CreateUpdateResume from 'components/job-application/CreateUpdateResume';
// import JobRelatedPreferences from 'pages/candidate/JobRelatedPreferences';
// import ExpetiesAndSkills from 'pages/candidate/ExpertiesAndSkills'

import JobPreferences from 'components/job-preferences/JobPreferences';

import Registration from 'pages/auth/Registration';
import LoginPage from 'pages/auth/LoginPage';
import PasswordReset from 'pages/auth/PasswordReset';

import ForgotPassword from 'components/login/ForgotPassword';
import EnterOTP from 'components/login/EnterOTP';
import RedirectPage from 'components/login/Redirect';

import ResetPassword from 'components/login/ResetPassword';

import CompanyList from 'pages/company/CompanyList';
import CompanyMaster from 'pages/company/CompanyMaster';
import CompanyStaffForm from 'pages/company/CompanyStaffForm';
import ManageUser from 'pages/company/ManageUser';

import JobsApplyApplication from 'pages/application/JobsApplyApplication';
import ApplicationList from 'pages/application/ApplicationList';
import JobAndApplicationDetails from 'pages/application/JobAndApplicationDetails';

import JobApplicants from 'pages/admin/JobApplicants';
import CandidateApplications from 'pages/admin/CandidateApplications';
import CandidatesList from 'pages/admin/CandidatesList';
import UserManagement from 'pages/admin/UserManagement';
import RecommendationJobStatsPage from 'pages/admin/RecommendationJobStatsPage';

// feedback
import FeedbackList from 'pages/feedback/FeedbackList';

import { SplashScreen } from 'components/loading-screen';

import Register from 'components/login/Register';
import ChooseResumeTemplate from 'components/choose-resume-template/ChooseResumeTemplate';
import JobApplication from 'components/job-application/JobApplication';
import NewJobPosting from 'components/admin/newJobPosting';
// import Dashboard from 'components/admin/Dashboard';
import JobDetails from 'components/job-application/JobDetails';
import InternalJobFromExternal from 'components/job-application/InternalJobFromExternal';
import { element } from 'prop-types';
import MasterDataUpdate from 'pages/admin/MasterDataUpdate';

// ----------------------------------------------------------------------
export default function Router({ }) {
  const { loading, user } = useAuth();

  if (loading) return <SplashScreen />;

  let children = [];
  switch (user?.user_type) {
    case 'user':
      children = [
        { path: 'home', element: (user?.stages === 1 || user?.stages === 2) ? <BasicProfile /> : (user?.stages === 3) ? < JobPreferences /> : (user?.stages === 4) ? <JobApplication /> : <BasicProfile /> },
        { path: 'job-application', element: <JobApplication /> },
        { path: 'resume', element: <ChooseResumeTemplate /> },
        { path: 'job-preferences', element: < JobPreferences /> },
        { path: 'profile', element: <BasicProfile /> },
        { path: 'registration-upload-resume', element: <RegistrationUploadResume /> },
        { path: 'create-update-resume', element: <CreateUpdateResume /> },
      ];
      break;

    case 'company':
      children = [
        { path: 'home', element: <JobList /> },
        { path: 'candidates', element: <CandidatesList /> },
        { path: 'candidate-applications/:id', element: <CandidateApplications /> },
        { path: 'profile', element: <Profile /> },
        { path: 'company-profile', element: <CompanyMaster /> },
        { path: 'reset-password', element: <PasswordReset /> },
        { path: 'job-applicants/:id', element: <JobApplicants /> },
        { path: 'job-form', element: <NewJobPosting /> },
        { path: 'company-details/:id', element: <CompanyMaster /> },
        { path: 'add-staff/:id', element: <CompanyStaffForm /> },
        { path: 'staff-details/:id', element: <CompanyStaffForm /> },
        { path: 'manage-user', element: <ManageUser /> },
        { path: 'settings', element: <PasswordReset /> },
        // { path: 'feedback', element: <FeedbackList /> },
      ];
      break;

    case 'companyadmin':
      children = [
        { path: 'home', element: <JobList /> },
        { path: 'candidates', element: <CandidatesList /> },
        { path: 'candidate-applications/:id', element: <CandidateApplications /> },
        { path: 'profile', element: <Profile /> },
        { path: 'settings', element: <PasswordReset /> },
        { path: 'job-applicants/:id', element: <JobApplicants /> },
        { path: 'job-form', element: <NewJobPosting /> },
        { path: 'company-details/:id', element: <CompanyMaster /> },
        { path: 'add-staff/:id', element: <CompanyStaffForm /> },
        { path: 'staff-details/:id', element: <CompanyStaffForm /> },
        { path: 'manage-user', element: <ManageUser /> },
        // { path: 'feedback', element: <FeedbackList /> },
      ];
      break;

    case 'recruiter':
      children = [
        { path: 'home', element: <JobList /> },
        { path: 'candidates', element: <CandidatesList /> },
        { path: 'candidate-applications/:id', element: <CandidateApplications /> },
        { path: 'profile', element: <Profile /> },
        { path: 'settings', element: <PasswordReset /> },
        { path: 'job-applicants/:id', element: <JobApplicants /> },
        { path: 'job-form', element: <NewJobPosting /> },
        { path: 'company-details/:id', element: <CompanyMaster /> },
        { path: 'company-profile', element: <CompanyMaster /> },
        { path: 'add-staff/:id', element: <CompanyStaffForm /> },
        { path: 'staff-details/:id', element: <CompanyStaffForm /> },
        { path: 'manage-user', element: <ManageUser /> },
        // { path: 'feedback', element: <FeedbackList /> },
      ];
      break;

    case 'admin':
      children = [
        { path: 'home', element: <JobList /> },
        { path: 'candidates', element: <CandidatesList /> },
        { path: 'candidate-applications/:id', element: <CandidateApplications /> },
        { path: 'companies', element: <CompanyList /> },
        { path: 'profile', element: <Profile /> },
        { path: 'settings', element: <PasswordReset /> },
        { path: 'job-applicants/:id', element: <JobApplicants /> },
        { path: 'user-manage', element: <UserManagement /> },
        { path: 'job-form', element: <NewJobPosting /> },
        { path: 'company-profile', element: <CompanyMaster /> },
        { path: 'company-details/:id', element: <CompanyMaster /> },
        { path: 'add-staff/:id', element: <CompanyStaffForm /> },
        { path: 'staff-details/:id', element: <CompanyStaffForm /> },
        // { path: 'feedback', element: <FeedbackList /> },
        { path: 'update-master-data', element: <MasterDataUpdate /> },
      ];
      break;

    case 'superadmin':
      children = [
        { path: 'home', element: <JobList /> },
        { path: 'candidates', element: <CandidatesList /> },
        { path: 'candidate-applications/:id', element: <CandidateApplications /> },
        { path: 'companies', element: <CompanyList /> },
        { path: 'profile', element: <Profile /> },
        { path: 'settings', element: <PasswordReset /> },
        { path: 'recommendation-stats', element: <RecommendationJobStatsPage /> },
        { path: 'job-applicants/:id', element: <JobApplicants /> },
        { path: 'user-manage', element: <UserManagement /> },
        { path: 'job-form', element: <NewJobPosting /> },
        { path: 'company-profile', element: <CompanyMaster /> },
        { path: 'company-details/:id', element: <CompanyMaster /> },
        { path: 'add-staff/:id', element: <CompanyStaffForm /> },
        { path: 'staff-details/:id', element: <CompanyStaffForm /> },
        // { path: 'feedback', element: <FeedbackList /> },
        { path: 'update-master-data', element: <MasterDataUpdate /> },
      ];
      break;
    default:
      break;
  }

  const otherPaths = [
    {
      path: `${process.env.REACT_APP_HOMEPAGE}register`,
      element: <Register />,
    },
    {
      path: `${process.env.REACT_APP_HOMEPAGE}forgot-password`,
      element: <ForgotPassword />,
    },
    {
      path: `${process.env.REACT_APP_HOMEPAGE}loginlink/:token`,
      element: <RedirectPage />,
    },
    {
      path: `${process.env.REACT_APP_HOMEPAGE}enter-otp`,
      element: <EnterOTP />,
    },
    {
      path: `${process.env.REACT_APP_HOMEPAGE}reset-password`,
      element: <ResetPassword />,
    },
    {
      path: `${process.env.REACT_APP_HOMEPAGE}forgot-password`,
      element: <ForgotPassword />,
    },
    {
      path: `${process.env.REACT_APP_HOMEPAGE}reset-password`,
      element: <ResetPassword />,
    },
    {
      path: `${process.env.REACT_APP_HOMEPAGE}404`,
      element: <Page404 />
    },
    {
      path: '*',
      element: <Navigate to={user ? `${process.env.REACT_APP_HOMEPAGE}404` : `${process.env.REACT_APP_HOMEPAGE}`} replace />,
    },
    {
      path: `${process.env.REACT_APP_HOMEPAGE}jobs/:id`,
      element: <InternalJobFromExternal />,
    },
    {
      path: `${process.env.REACT_APP_HOMEPAGE}jobs`,
      element: <InternalJobFromExternal />,
    },
  ];

  const routes = useRoutes([
    {
      path: `${process.env.REACT_APP_HOMEPAGE}`,
      element: (user ? <DashboardLayout isDrowerShow={true} /> : <LoginPage />),
      children: user ? [
        ...children,
        { element: <Navigate to={`${process.env.REACT_APP_HOMEPAGE}home`} />, index: true }
      ] : [],
    },
    {
      path: `${process.env.REACT_APP_HOMEPAGE}/jobs`,
      element: <DashboardLayout isDrowerShow={false} />,
      children: [
        {
          path: `${process.env.REACT_APP_HOMEPAGE}jobs`,
          element: <InternalJobFromExternal />,
          index: true
        },
        {
          path: `${process.env.REACT_APP_HOMEPAGE}jobs/:id`,
          element: <InternalJobFromExternal />,
        },
      ],
    },
    ...otherPaths,
  ]);

  return routes;

}